import SingleDepot from './SingleDepot';

export default SingleDepot;
